import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  Chip,
  LinearProgress,
  Avatar,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  SentimentVerySatisfiedRounded,
  SentimentNeutralRounded,
  SentimentVeryDissatisfiedRounded,
  FavoriteRounded,
  EmojiObjectsRounded,
  ChatRounded,
} from "@mui/icons-material";
import { theme as colorTheme, palette } from "../../../../Convoze.theme";




// const palette = {
//   bg: "#0b0b0f",
//   surface: "#0f1014",
//   card: "#111217",
//   border: "#1f1f23",
//   text: "#e5e7eb",
//   subtext: "#9aa0a6",
//   purple: "#7c3aed",
//   purpleLight: "#a78bfa",
//   green: "#10b981",
//   red: "#ef4444",
//   gray: "#9ca3af",
// };


const Bar = styled(LinearProgress)({
  height: 7,
  borderRadius: 8,
  backgroundColor: "#DAD6D6",
  "& .MuiLinearProgress-bar": {
    borderRadius: 8,
    // background: `linear-gradient(90deg, #6366F1 0%, #9495dcff 50%, #a78bfa 100%)`,
    background: colorTheme('palette', 'primary').value
  },
});

export function Section({ icon, title, children, sx }) {
  return (
    <Paper
      elevation={0}
      sx={{
        // bgcolor: palette.surface,
        border: `0.5px solid #F1F1F3`,
        borderRadius: 5,
        p: { xs: 1.75, sm: 2.25 },
        ...sx,
        backgroundColor: "#fdfdffff",
        boxShadow:
          "var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          mb: { xs: 1.5, sm: 2 },
        }}
      >
        <Box
          sx={{
            display: "grid",
            placeItems: "center",
          }}
        >
          {icon}
        </Box>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 600,
            fontSize: "1rem",
            lineHeight: "1.75rem",
            color: "#424242",
          }}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </Paper>
  );
}

export function SentimentItem({ icon, color, percent, label, calls, bgcolor }) {
  return (
    <Box sx={{ textAlign: "center" }}>
      <Box
        sx={{
          width: 40,
          height: 40,
          bgcolor: bgcolor,
          boxShadow: `inset 0 0 0 2px ${color}20`,
          color: color,
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mx: "auto",
          gap: 1,
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="body1"
        sx={{
          fontWeight: 600,
          fontSize: "1.2rem",
          mt: 2.5,
          lineHeight: "2rem",
        }}
      >
        {percent}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          color: "hsl(240 3.8% 46.1%)",
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
        }}
      >
        {label}
      </Typography>
      <Typography
        variant="caption"
        sx={{
          opacity: 0.9,
          // color: "hsl(240 3.8% 46.1%)",
          fontSize: "0.75rem",
          lineHeight: "1rem",
        }}
      >
        {calls}
      </Typography>
    </Box>
  );
}

export function EmotionRow({ name, value }) {
  return (
    <Box sx={{ mb: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 0.75,
        }}
      >
        <Typography variant="body2" sx={{}}>
          {name}
        </Typography>
        <Typography variant="caption" sx={{}}>
          {value}%
        </Typography>
      </Box>
      <Bar variant="determinate" value={value} />
    </Box>
  );
}

export function FeedbackItem({ sentiment = "Positive", text, timeAgo }) {
  const map = {
    positive: {
      label: "positive",
      fg: "black",
      // bd: "rgba(16,185,129,0.35)",
      // bg: "rgba(16,185,129,0.12)",
      bd :colorTheme('palette', 'positiveBg').value,
      bg:colorTheme('palette', 'primary').value
    },
    neutral: {
      label: "neutral",
      fg: "black",
      // bd: "rgba(148,163,184,0.35)",
      // bg: "rgba(148,163,184,0.15)",
       bd :colorTheme('palette', 'neutralBg').value,
      bg:colorTheme('palette', 'neutral').value
    },
    negative: {
      label: "negative",
      fg: "black",
      // bd: "rgba(239,68,68,0.35)",
      // bg: "rgba(239,68,68,0.12)",
      bd :colorTheme('palette', 'negativeBg').value,
      bg:colorTheme('palette', 'negtive').value
    },
  };
  const cfg = map[sentiment] ?? map.positive;

  return (
    <Paper
      elevation={0}
      sx={{
        // border: `0.5px solid #D2D2D2`,
        borderRadius: 5,
        p: { xs: 1.5, sm: 2 },
        bgcolor: "hsl(240deg 4.8% 95.9% / 30%)",
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Chip
          size="small"
          label={sentiment}
          icon={<SentimentVerySatisfiedRounded sx={{ fontSize: 14 }} />}
          sx={{
            height: 24,
            color:
              sentiment == "Positive"
                ? "#2CC562"
                : sentiment == "Negative"
                ? "#EF4444"
                : "#FFBF00",
            bgcolor: "#fff",
            border: `1px solid ${
              sentiment == "Positive"
                ? "#2CC562"
                : sentiment == "Negative"
                ? "#EF4444"
                : "#FFBF00"
            }`,
            "& .MuiChip-icon": {
              color:
                sentiment == "Positive"
                  ? "#2CC562"
                  : sentiment == "Negative"
                  ? "#EF4444"
                  : "#FFBF00",
              ml: 0.5,
            },
            fontWeight: 700,
          }}
        />
        <Typography variant="caption" sx={{}}>
          {timeAgo}
        </Typography>
      </Box> */}
      <Typography
        variant="body2"
        sx={{
          fontStyle: "italic",
          "&::before": { content: '"\\""' },
          "&::after": { content: '"\\""' },
        }}
      >
        {text}
      </Typography>
    </Paper>
  );
}

export default function VibeCheck({ agentKpisData }) {
  const mergedCustomerFeedback = [
    ...(agentKpisData?.customerFeedbackTrends?.topStrengths || []),
    ...(agentKpisData?.customerFeedbackTrends?.topImprovements || []),
  ];
  return (
    <Box sx={{}}>
      {/* Title */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Typography
          variant="h2"
          sx={{
            lineHeight: "1.75rem",
            mb: 0.25,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "#424242",
            fontSize: "1.125rem",
            fontWeight: 700,
          }}
        >
          Vibe Check
        </Typography>
        <Chip
          size="small"
          label="Positive"
          icon={<FavoriteRounded sx={
            // { color: "#fbbf24 !important" }
            {color : `${colorTheme('palette', 'neutral').value} !important`}
          } />}
          sx={{
            bgcolor: "#F1EBFD",
            // color: "#7C3AED",
            color:colorTheme('palette', 'primary').value,
            height: 22,
            "& .MuiChip-icon": { ml: 0.5 },
            fontSize: "0.75rem",
            lineHeight: "1rem",
          }}
        />
      </Box>

      {/* Sentiment Distribution */}
      <Section
        // icon={<EmojiObjectsRounded fontSize="small" />}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            // color="#6366F1"
            color={colorTheme('palette', 'primary').value}
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-brain w-5 h-5 text-primary"
            data-lov-id="src/components/dashboard/SentimentAnalysis.tsx:51:10"
            data-lov-name="Brain"
            data-component-path="src/components/dashboard/SentimentAnalysis.tsx"
            data-component-line="51"
            data-component-file="SentimentAnalysis.tsx"
            data-component-name="Brain"
            data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
          >
            <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"></path>
            <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"></path>
            <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4"></path>
            <path d="M17.599 6.5a3 3 0 0 0 .399-1.375"></path>
            <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5"></path>
            <path d="M3.477 10.896a4 4 0 0 1 .585-.396"></path>
            <path d="M19.938 10.5a4 4 0 0 1 .585.396"></path>
            <path d="M6 18a4 4 0 0 1-1.967-.516"></path>
            <path d="M19.967 17.484A4 4 0 0 1 18 18"></path>
          </svg>
        }
        title="Sentiment Distribution"
      >
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={12} sm={4}>
            <SentimentItem
              icon={<SentimentVerySatisfiedRounded />}
              // color={"#22C55E"}
              color={colorTheme('palette', 'positive').value}
              bgcolor="#E6F7EC"
              percent={
                agentKpisData?.sentimentPercentages?.neutral
                  ? `${agentKpisData?.sentimentPercentages?.neutral}%`
                  : "0"
              }
              label="Positive"
              calls="145 calls"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <SentimentItem
              icon={<SentimentNeutralRounded />}
              // color="#FFBF00"
              color={colorTheme('palette', 'neutral').value}
              bgcolor="#faf0d4ff"
              percent={
                agentKpisData?.sentimentPercentages?.neutral
                  ? `${agentKpisData?.sentimentPercentages?.neutral}%`
                  : "0"
              }
              label="Neutral"
              calls="67 calls"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <SentimentItem
              icon={<SentimentVeryDissatisfiedRounded />}
              // color={"#EF4444"}
              color={colorTheme('palette', 'negative').value}
              bgcolor="#f7e8e8ff"
              percent={
                agentKpisData?.sentimentPercentages?.negative
                  ? `${agentKpisData?.sentimentPercentages?.negative}%`
                  : "0"
              }
              label="Negative"
              calls="23 calls"
            />
          </Grid>
        </Grid>
      </Section>

      {/* Emotion Analysis */}
      <Section
        // icon={<FavoriteRounded fontSize="small" />}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            // color="#6366F1"
            color={colorTheme('palette', 'primary').value}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-heart w-5 h-5 text-primary"
            data-lov-id="src/components/dashboard/SentimentAnalysis.tsx:80:10"
            data-lov-name="Heart"
            data-component-path="src/components/dashboard/SentimentAnalysis.tsx"
            data-component-line="80"
            data-component-file="SentimentAnalysis.tsx"
            data-component-name="Heart"
            data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
          >
            <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
          </svg>
        }
        title="Emotion Analysis"
        sx={{ mt: 2 }}
      >
        <EmotionRow
          name="Happiness"
          value={
            agentKpisData?.emotionAnalysis?.Happiness
              ? agentKpisData?.emotionAnalysis?.Happiness
              : 0
          }
        />
        <EmotionRow
          name="Confidence"
          value={
            agentKpisData?.emotionAnalysis?.Confidence
              ? agentKpisData?.emotionAnalysis?.Confidence
              : 0
          }
        />
        <EmotionRow
          name="Calmness"
          value={
            agentKpisData?.emotionAnalysis?.Calmness
              ? agentKpisData?.emotionAnalysis?.Calmness
              : 0
          }
        />
        <EmotionRow
          name="Empathy"
          value={
            agentKpisData?.emotionAnalysis?.Empathy
              ? agentKpisData?.emotionAnalysis?.Empathy
              : 0
          }
        />

        <EmotionRow
          name="Frustration"
          value={
            agentKpisData?.emotionAnalysis?.Frustration
              ? agentKpisData?.emotionAnalysis?.Frustration
              : 0
          }
        />
      </Section>

      {/* Recent Feedback */}
      <Section
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            // color="#6366F1"
            color={colorTheme('palette', 'primary').value}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="lucide lucide-message-circle w-5 h-5 text-primary"
            data-lov-id="src/components/dashboard/SentimentAnalysis.tsx:102:10"
            data-lov-name="MessageCircle"
            data-component-path="src/components/dashboard/SentimentAnalysis.tsx"
            data-component-line="102"
            data-component-file="SentimentAnalysis.tsx"
            data-component-name="MessageCircle"
            data-component-content="%7B%22className%22%3A%22w-5%20h-5%20text-primary%22%7D"
          >
            <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
          </svg>
        }
        title="Recent Customer Feedback"
        sx={{ mt: 2 }}
      >
        <Grid container spacing={1.5}>
          <Grid item xs={12}>
            {mergedCustomerFeedback?.length > 0
              ? mergedCustomerFeedback?.map((feed) => {
                  return (
                    <FeedbackItem
                      sentiment="Positive"
                      text={feed?.text}
                      timeAgo="2 hours ago"
                    />
                  );
                })
              : ""}
          </Grid>
        </Grid>
      </Section>
    </Box>
  );
}
